import { useMutation } from "react-query";
import Modal from "../../common/components/Modal";
import FormBuilder from "../../common/components/formInputs/FormBuilder";
import usePages from "../../common/hooks/pages/usePages";
import { usePopup } from "../../common/contexts/PopupContext";

function getFormInputs(pageName) {
  return [
    {
      type: "text",
      label: "Page name",
      name: "pageName",
      placeholder: "Page name",
      validation: {
        required: "Page name is required",
      },
      defaultValue: pageName,
    },
  ];
}

function PageForm({ open, setOpen, title, onSuccess, pageId, pageName }) {
  const { createPage, updatePage } = usePages();

  const { toast } = usePopup();

  const { mutate: createPageMutate, isLoading } = useMutation({
    mutationFn: createPage,
    onSuccess: (res) => {
      const { message } = res?.data || {};

      if (onSuccess) {
        onSuccess();
      }

      toast(message, "success");
      setOpen(false);
    },
    onError: (error) => {
      const message =
        error?.response?.data?.message ||
        "Something went wrong while creating page!";

      toast(message, "error");
    },
  });

  const { mutate: updatePageMutate, isLoading: isUpdating } = useMutation({
    mutationFn: updatePage,
    onSuccess: (res) => {
      const { message } = res?.data || {};

      if (onSuccess) {
        onSuccess();
      }

      toast(message, "success");
      setOpen(false);
    },
    onError: (error) => {
      const message =
        error?.response?.data?.message ||
        `Something went wrong while ${pageId ? "updating" : "creating"} page!`;

      toast(message, "error");
    },
  });

  return (
    <div>
      <Modal
        title={title || `${pageId ? "Update" : "Create"} Page`}
        open={open}
        setOpen={setOpen}
      >
        <FormBuilder
          formInputs={getFormInputs(pageName)}
          submitButtonLabel={pageId ? "Update" : "Create"}
          onSubmit={(data) => {
            if (pageId) {
              const variables = {
                payload: data,
                pageId,
              };

              updatePageMutate(variables);
              return;
            }

            createPageMutate(data);
          }}
          isSubmitting={isLoading || isUpdating}
          submitBtnContainerCls="!my-2"
        />
      </Modal>
    </div>
  );
}

export default PageForm;
